export const getBoolListForSelectedEnv = (selected, env) => {
    let ret = [];
    const selectedEnvID = [];

    if (env) {
        for (let e of selected) {
            selectedEnvID.push(e.envID);
        }

        env.forEach((e, index) => {
            if (selectedEnvID.includes(e.envID)) {
                ret.push(true);
            } else {
                ret.push(false);
            }
        });
    }

    return ret;
};
